module.exports = __webpack_public_path__ + "img/product--package.d684faaf.png";